var map = {
	"./BuddhaAkshay/images/Finance_app.svg": [
		75071,
		71
	],
	"./JanBhavishya/images/Finance_app.svg": [
		99902,
		902
	],
	"./Suvarna/images/Finance_app.svg": [
		20956,
		956
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73884;
module.exports = webpackAsyncContext;